<div class="db-booster-account-upgraded">
    <h2 class="mb5" [innerHTML]="('text_successfullyUpgradedFromBooster') | dbText : {subscription :!subscription?.boosterProClient?
            'Booster Free' : subscription?.category === UserSubscriptionCategory.PERSONAL ?
              'Booster Personal' : subscription?.category === UserSubscriptionCategory.PREMIUM ?
                'Booster Premium' : subscription?.category === UserSubscriptionCategory.ENTERPRISE ?
                  'Booster Agency' : ''}"></h2>
    <p class="mb20" *ngIf="subscription?.category !== UserSubscriptionCategory.ENTERPRISE">{{('text_upgradedFromBoosterTrialInfo') | dbText : {count: subscription?.plan?.totalDomainCount, plural: (subscription?.plan?.totalDomainCount > 1 ? 's' : '')} }}</p>
    <p class="mb20" *ngIf="subscription?.category === UserSubscriptionCategory.ENTERPRISE">{{('text_upgradedFromBoosterTrialInfoAgency') | dbText : {count: subscription?.plan?.totalDomainCount, plural: (subscription?.plan?.totalDomainCount > 1 ? 's' : '')} }}</p>

    <ul class="db-booster-account-upgraded__points mb20">
      <li *ngFor="let point of cdnPoints">
        <i class="db-icon db-icon-ds-checkmark-bg"></i>
        <div>
          <b [innerHTML]="point.title"></b>
          <ul *ngIf="point.subPoints" class="db-booster-account-upgraded__sub-points">
            <li *ngFor="let subPoint of point.subPoints">
              <p [innerHTML]="subPoint"></p>
            </li>
          </ul>
        </div>
      </li>
    </ul>
    <div class="db-booster-account-upgraded__buttons-wrap text-center mt30">
      <button class="ds-btn-black ds-btn-xl" (click)="onProceed.emit()"><span>Proceed</span></button>
    </div>
</div>
